import { useState, useEffect } from "react";
import useBlock from "/src/features/editor/hook/block/useBlock";
import ChatboxService from "/src/features/chatbox/actions/ChatboxAction";
import editorAction from "../../actions/editorAction";

import { useTreeStateContext } from "../../contexts/TreeContext";
import binarySearchString from "../../utils/binarySearchString";
import useCategories from "../../hook/category/useCategories";

function useBlockMenu(id) {
    const [show, setShow] = useState(false);

    const [onClick, setOnClick] = useState(false);

    const { openIfClosed } = ChatboxService();

    const { deleteBlock, duplicateBlock, jumpBlock } = useBlock();

    const { getCategoryById,ungroupBlockFromCategory } = useCategories();

    const { blocks, categories } = useTreeStateContext();

    const { updateBlocksName } = editorAction();

    const getBlockByObjectId = (id) => {
        const indexBlock = binarySearchString(blocks, id, 'object_id');
        return blocks[indexBlock];
    }

    const onClickPlay = async (e) => {
        const duration = document.getElementsByClassName('editor-window').item(0) ? 0 : 350;
        setTimeout(() => openIfClosed(), duration);
        setOnClick(true);
    }


    const onClickDuplicate = async (_id = -1) => {
        await duplicateBlock(_id != -1 ? _id : id);
        setShow(false);
    }

    const onClickJump = (_id = -1) => {
        jumpBlock(_id != -1 ? _id : id);
        setShow(false);
    }

    const updateBlockOnDelete = (classname, id) => {
        if (classname != 'scenario') {
            return;
        }
        const block = getBlockByObjectId(id)
        if (!block) return;

        const name = block.name;
        const blocksToUpdate = blocks.filter(block => block.type.name == 'magic' && block.name == `Jump to ${name}`).map(block => { return { ...block, name: `Jump to ...` } });
        if (blocksToUpdate.length == 0) return;

        updateBlocksName(blocksToUpdate);
    }

    const updateCategoryOnDelete = async (_id = -1)=>{
        const block = getBlockByObjectId(_id != -1 ? _id : id)
        if (block.bot_category_id == null){
            return
        }
        await ungroupBlockFromCategory(block)
    }

    const onClickDelete = async (classname,deletable, _id = -1) => {
        if (!deletable) {
            return;
        }
        let idBlock = _id != -1 ? _id : id
        const block = getBlockByObjectId(idBlock)
        
        let infoCategory = getCategoryById(block.bot_category_id);
        if (infoCategory != null && infoCategory.category.locked){
            return;
        }
        await updateCategoryOnDelete(idBlock);
        updateBlockOnDelete(classname, idBlock);
        setShow(false);
        await deleteBlock(idBlock);
    }

    const onClickDeleteFromCategory = async () => {
        const block = getBlockByObjectId(id)
        if (!block) return;
        ungroupBlockFromCategory(block)
    }

    const getCategory = ()=>{
        let block = getBlockByObjectId(id)
        if (block == null || block.bot_category_id == null) return;

        let category = categories.find( infoCategory => infoCategory.category.id == block.bot_category_id)?.category;
        return category;
    }

    return { onClickPlay, onClickDuplicate, onClickJump, onClickDelete,onClickDeleteFromCategory,getCategory,show, setShow, onClick, setOnClick};
}

export default useBlockMenu;